 <template>
    <v-container fluid>
        <v-card>
          <v-toolbar>
            <v-icon>dynamic_feed</v-icon>
            <v-toolbar-title class="font-weight-light">&nbsp;Control de Cajas</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                  <v-icon v-if="action.esFrecuente">favorite</v-icon>
                  <v-icon v-else>favorite_border</v-icon>
                </v-btn>
              </template>
              <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
              <span v-else>Agregar a Tareas Frecuentes</span>  
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-row align="center">
                <v-col>
                    <v-autocomplete v-model="filtro.empresaId" :items="empresas" autocomplete="disabled"
                        item-text="nombre" item-value="id" label="Cajas de la Empresa" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
                </v-col>
                <v-col>
                    <v-autocomplete v-model="filtro.sucursalId" :items="sucursales" autocomplete="disabled"
                        item-text="nombre" item-value="id" label="de la Sucursal" placeholder="Seleccione una Empresa Primero" :menu-props="{minWidth:'400'}"></v-autocomplete>
                </v-col>
                <v-col>
                    <v-text-field v-model="filtro.fecha" label="Fecha de Caja" type="date" prepend-icon="event"></v-text-field>
                </v-col>
                <v-col cols="2" lg="1">
                    <v-btn dark  color="green" @click="getItems">Buscar</v-btn>
                </v-col>
            </v-row>
            
            <v-flex>
                <v-card >
                  <v-toolbar dense :color="$store.state.UiColors.crudToolbarList">
                    <v-icon>list</v-icon>
                    <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-switch v-model="agruparPorSucursal" label="Agrupar por Sucursal"></v-switch>
                  </v-toolbar>
                  <v-data-table 
                    loading-text="Buscando registros"
                    dense
                    :headers="headers"
                    :items="records"
                    :rows-per-page="pagination.itemsPerPage"
                    :options.sync ="pagination"
                    v-model="selectedRows"
                    :loading="loading"  
                    class="elevation-1"
                    :footer-props="footer"
                    item-key="id"
                    :group-by="agruparPorSucursal? 'sucursal':null"
                  >
                  
                  <template slot="no-data">
                        <v-alert :value="true" icon="warning" dense>
                          No se encontraron registros con los filtros ingresados
                        </v-alert>
                  </template>

                  <template v-slot:item="{ item }">
                      <tr>
                        <td>
                            <v-speed-dial direction="right" :open-on-hover='true' >
                                <template v-slot:activator>
                                <v-btn slot="activator" color="orange" fab text small>
                                    <v-icon color="orange" >touch_app</v-icon>                                
                                </v-btn>
                                </template>

                                <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn fab dark small color="blue" v-on="on" @click.stop="listados(item.cajaId)">
                                    <v-icon>file_copy</v-icon>
                                    </v-btn>
                                </template>
                                <span>Listados</span>
                                </v-tooltip>

                                <v-tooltip bottom v-if="item.estadoCaja == 'Cerrada'">
                                <template v-slot:activator="{ on }">
                                    <v-btn fab dark small color="green" v-on="on" @click.stop="abrirCaja(item.cajaId)">
                                    <v-icon>lock_open</v-icon>
                                    </v-btn>
                                </template>
                                <span>Abrir Caja</span>
                                </v-tooltip>

                                <v-tooltip bottom v-if="item.estadoCaja == 'Abierta'">
                                <template v-slot:activator="{ on }">
                                    <v-btn fab dark small color="brown" v-on="on" @click.stop="cerrarCaja(item.cajaId)">
                                    <v-icon>lock</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar Caja</span>
                                </v-tooltip>

                            </v-speed-dial>

                        </td>

                        <td class="text-xs-left caption">{{ item.cajaDescripcion }}</td>
                        <td class="text-xs-left caption">{{ item.saldoInicial | currency }}</td>
                        <td class="text-xs-left caption">{{ item.importeCobranzas | currency }}</td>
                        <td class="text-xs-left caption">{{ item.importeIngresosVarios | currency }}</td>
                        <td class="text-xs-left caption">{{ item.importeLiquidaciones | currency }}</td>
                        <td class="text-xs-left caption">{{ item.importeEgresosVarios | currency }}</td>                        
                        <td class="text-xs-left caption">{{ item.saldoFinal | currency}}</td>

                        <td class="text-xs-left caption">{{ item.estadoCaja }}</td>

                        <td class="text-xs-left caption" v-if="!agruparPorSucursal">{{ item.sucursal }}</td>
                        <td class="text-xs-left caption"><v-chip small :color="item.empresaColor" label dark>{{item.empresaShort}}</v-chip></td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card >
            </v-flex>
            <v-divider></v-divider>
          </v-card-text>

          <v-card-actions>

          </v-card-actions>
        </v-card >

        <template v-if="$store.state.debugModeOn">
          Debug Info: <p></p>
          
          Model: {{filtro}}  <p></p>                            
        </template>
    </v-container>
      
</template>

<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'


export default {

  data() {
    return {
      loading: false,
      pagination: { // definición de paginación
        sortDesc:[true],
        sortBy:[''],
        page: 1,
        itemsPerPage: 5
      },
      footer:{        
        showFirstLastPage: true,
        itemsPerPageOptions:[5,10,20, 50]
      },
      totalItems: 0, // va afuera de pagination 
      headers: [ // definición de columnas
        { text: 'Acciones', value: 'accion', width:80, sortable:false },
        { text: 'Caja', value: 'cajaDescricpion'},
        { text: 'Saldo Inicio', value: 'saldoInicial'},
        { text: 'Cobranzas', value: 'importeCobranzas'},
        { text: 'Otros Ingresos', value: 'importeIngresosVarios'},
        { text: 'Pagos Créd.', value: 'importeLiquidaciones'},
        { text: 'Otros Egresos', value: 'importeEgresosVarios'},
        { text: 'Saldo Actual', value: 'saldoFinal'},
        { text: 'Estado', value: 'estadoCaja'},
        { text: 'Sucursal', value: 'sucursal'},
        { text: 'Empresa', value: 'empresa'},
      ],
      records: [], // registros
      selectedRows: [],
      filtro: {empresaId:0, sucursalId:0, cajaId:0,  fecha:null},
      empresas: [],
      sucursales:[],
      cajas:[],
      agruparPorSucursal: true
    };
  },
  async created() {   
      this.loadEmpresas();
      this.loadCajas();
      this.filtro.fecha = this.$moment(new Date()).format('YYYY-MM-DD');
  },  
  watch: {    
    'filtro.empresaId': function(){        
        this.loadSucursales();
    },

  },
  computed: {
    ...mapGetters(['getActionFromLink','user']),
    action: function(){
      return this.getActionFromLink(this.$route.path)
    },
  },
  methods: {
    ...mapMutations(["setActiveTask", "setActiveSubTask", "alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),
    async listados (cajaId){
        var caja = this.cajas.find(c=>c.id == cajaId);
        caja.abiertaEl = this.filtro.fecha; // lo seteo, para que se tome de los listados
        
        var params = {
            width:500,
            temporary: true,
            caja: caja,
        };

        this.setActiveTask({task:'app-listados-caja', props: params});
    },
    async cerrarCaja (cajaId){
        var caja = this.cajas.find(c=>c.id == cajaId);

        var params = {
            width:500,
            temporary: true,
            caja: caja,
            accionCompleta: this.cierreConfirmado
        };

        this.setActiveTask({task:'app-cierre-caja', props: params});
    },
    async cierreConfirmado(){
        await this.getItems(); // recargo los estados de las cajas                    
    },
    async abrirCaja (cajaId){
        var caja = this.cajas.find(c=>c.id == cajaId);
        
        var params = {
            cajaId: caja.id, 
            fecha: this.filtro.fecha
        };

        this.loading = true
        try {
            var result = await  http.post('cajas/abrircaja', JSON.stringify( params )); 

            if(result.seCambio){
                this.alertSuccess('La Caja ha sido abierta')

                await this.loadCajas(); // recargo los estados de las cajas
                await this.getItems(); // recargo los estados de las cajas
            }
            else{
                this.alertWarning(result.motivo)
            }

        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },    
    async getItems() {
      if(this.filtro.empresaId <0)
      {
        this.alertWarning('Debe elegir una Empresa.');
        return;
      }
      
      if(this.filtro.sucursalId < 0)
      {
        this.alertWarning('Debe elegir una Sucursal.');
        return;
      }

      if(this.filtro.fecha === undefined)
      {
        this.alertWarning('Debe ingresar la Fecha de Caja.');
        return;
      }

      this.loading = true
      
      let filter = this.filtro;

      try {
        var result = await http.get('cajas/listsaldos?empresaId='+filter.empresaId 
                                    + '&sucursalId='+filter.sucursalId 
                                    + '&cajaId=0'  // todas las cajas
                                    + '&monedaId=1' //pesos
                                    + '&fechaCaja=' + filter.fecha
                                    );
        
        this.records = result.list;
        this.totalItems = result.list.length

      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.loading = false
    },    
    async loadEmpresas(){
      this.loading = true;
      try{
        var result = await http.get('empresas/list/porusuario?usuarioId='+this.user.id);

        this.empresas = result.list;
        this.empresas.unshift({id:0,nombre:'(Todas)'});
        
        this.loadSucursales();
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadSucursales(){
      this.loading = true;
      try{
        var result = await http.get('sucursales/list/porusuario?usuarioId='+this.user.id);
        
        this.sucursales = result.list.filter(i=>i.empresaId == this.filtro.empresaId || this.filtro.empresaId == 0);
        this.sucursales.unshift({id:0,nombre:'(Todas)'});
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadCajas(){
      this.loading = true;
      try{
        var result = await http.get('cajas');

        this.cajas = result.list;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
  }
}
</script>